import { GoogleAuthProvider } from 'firebase/auth'

import { signInWithOauth2 } from './sign_in_with_oauth2'

/**
 * Starts a sign in/up flows using Google. Emits an error if any
 */
export const signInWithGoogle = async () => {
	signInWithOauth2(new GoogleAuthProvider())
}
